import {BaseEvent} from "../BaseEvent";
import {MetricAlarmStatusLite} from "../../models/notification/MetricAlarmStatusLite";

export class MetricAlarmStatusChangedLiteNtf extends BaseEvent {
  public static NAME = 'metricAlarmStatusChangedLite';
  public value: MetricAlarmStatusLite;

  constructor(status: MetricAlarmStatusLite) {
    super(MetricAlarmStatusChangedLiteNtf.NAME);

    this.value = status;
  }
}
